import "../../css/components/Cells.scss";
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import VisibilitySensor from "react-visibility-sensor/visibility-sensor";
import Logger from "../utils/Logger";
import Link from "./Link";
import Text from "./Text";
import Dynamic from "./Dynamic";

const logger = new Logger(__filename);

class Cell extends Component {
  constructor() {
    super();
    this.state = {
      visible: false,
    };
  }

  componentDidMount = () => {
    if (this.props.enhancement && this.props.enhancement.init) {
      logger.log(`... enhancing content [${this.props.attrs.id}]`);
      this.props.enhancement.init(this);
    }
  };

  checkVisible = isVisible => {
    if (isVisible) {
      if (!this.state.visible) this.setState({ visible: true });
    }
  };

  render = () => {
    const content = this.props.contents.find(x => x.module !== "Text");
    const text = this.props.contents.find(x => x.module === "Text" && x.element === "h1");
    const bottomText = this.props.contents.find(x => x.module === "Text" && x.element === "p");
    if (content.module === "Carousel") {
      // this is provisional until each slide on cell carousel will have own link
      content.contents = content.contents.map(x => {
        x.targetUrl = null;
        if (x.contents && x.contents.length > 0) {
          x.contents = x.contents.map(x => {
            x.targetUrl = null;
            return x;
          });
        }
        return x;
      });
    }
    return (
      <VisibilitySensor onChange={isVisible => this.checkVisible(isVisible)} partialVisibility>
        <Fragment>
          <div className="cell-wrapper" style={this.props.style} {...this.props.dataAttrs}>
            <Link
              href={this.props.targetUrl}
              dataAttrs={this.props.dataAttrs}
              index={this.props.index}
              analytics={this.props.analytics}
              cell
            >
              {text ? <Text {...text} cell /> : null}
              <Dynamic {...content} />
            </Link>
          </div>
          {bottomText ? (
            <div className="cell-wrapper" id={`hm-message-wrapper-${this.props.dataAttrs["data-position"]}`}>
              <Text {...bottomText} cell attrs={{ className: "hm-message" }} />
            </div>
          ) : null}
        </Fragment>
      </VisibilitySensor>
    );
  };
}

Cell.defaultProps = {
  style: {},
};

Cell.propTypes = {
  attrs: PropTypes.object,
  analytics: PropTypes.object,
  contents: PropTypes.array,
  style: PropTypes.object,
};

export default Cell;
